export interface ContributionOutputApiModel{
    id: number,
    avatar: string,
    display_name: string,
    player_id: number,
    data: any,
    like_id: number,
    slug: string,
    story_id: number
}